import React from "react";
import "./3danimation.css";
function Doctor({ pic, title, dic }) {
  return (
    <>
      <div className='w-64 h-96 border hover:border-0 card-container'>
        <div className='card'>
          <div className='front'>
            <img src={pic} alt='thumb' className='h-72 w-full object-cover' />
            <div className='p-5'>
              <h1 className='text-primary text-xl sm:text-2xl'>{title}</h1>
              <p className='text-xs mt-0.5'>{dic}</p>
            </div>
          </div>
          <div className='p-5 text-gray-500 back'>
            <div>
              <div>
                <p className='text-center px-2 leading-8'>
                  “Even the all-powerful Pointing has no control about the blind
                  texts it is an almost unorthographic life One day however a
                  small line of blind text by the name of Lorem”
                </p>
              </div>
              <div className='flex items-center gap-2 absolute bottom-5'>
                <div>
                  <img
                    src={pic}
                    alt='thumb'
                    className='rounded-full object-cover w-14 sm:w-16 h-14 sm:h-16'
                  />
                </div>
                <div>
                  <h1>{title}</h1>
                  <p className='text-xs mt-0.5'>{dic}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Doctor;
